import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import DashboardLayout from "./components/Layout";
import Devices from "./components/devices/Devices";
import Settings from './components/settings/Settings';
import EditAccount from "./pages/EditAccount";
import UserProfile from "./pages/UserProfile";
import HomeScreen from "./pages/HomeScreen";


const App = ({ keycloakProfile }) => {
  return (
    <Router>
      <DashboardLayout keycloakProfile={keycloakProfile}>
        <Routes>
          <Route path="/" element={<Navigate to="/home" />} />
          <Route path="/home" element={<HomeScreen />} />
          <Route path="/devices" element={<Devices />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/edit-account" element={<EditAccount />} />
          <Route path="/user-profile" element={<UserProfile keycloakProfile={keycloakProfile} />} />
        </Routes>
      </DashboardLayout>
    </Router>
  );
};

export default App;
